import React from 'react'
import TypesFood from '../components/TypesFood'
import Marque from '../components/Marque'
import Footer from '../components/Footer'
import ProductSection from '../components/ProductSection'

const Products = () => {
  return (
    <div className='w-full flex flex-col gap-14'>
        <ProductSection isMob={false}/>
        <TypesFood/>
        <Marque 
            name="marque"
            padd='px-20 lg:px-28 xxl:px-36 xxxl:px-44 w-full aspect-[16/2] my-10'
            motherclassName='w-full h-full flex flex-row  justify-around items-center bg-primary02'
            className1='lg:text-[30px] xl:text-[35px] xxl:text-[40px] xxxl:text-[45px]'
            className2=''
          />
        <Footer/>
    </div>
  )
}

export default Products